import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';

import {
  getCampaignElementById,
  getIsQuestionPreview,
  hideFullQuestion,
} from '../../redux/modules/campaignLandingPage';
import UploadOrRecordSelector from './UploadOrRecordSelector';
import VideoPreview from './VideoPreview';
import styles from './FullQuestion.module.less';
import CameraRecord from '../CameraRecord/CameraRecord';
import UploadError from './UploadError';
import { RecordNotSupportedMessage } from '../../components';

const FullQuestion = ({ _hideFullQuestion, isPreview, question, qid, createMediaSubmissionFn }) => {
  const hideWhenPreview = isPreview ? styles.vpHide : '';

  return (
    <>
      <Icon
        data-testid={'FullQuestion-icon'}
        className={`${styles.vpCursorPointer} ${hideWhenPreview} ${styles.vpTogglePreview }`}
        icon="up"
        onClick={() => _hideFullQuestion(qid)}
      />
      <section
        data-testid={'FullQuestion-sectionOne'}
        className={`${styles.vpCursorPointer} ${hideWhenPreview}`}
        onClick={() => _hideFullQuestion(qid)}
      >
        <h4 className={styles.vpQuestionTitle}>
          {question.label}
          {question?.required && <span className={styles.vpRequiredLabel}>*</span>}
        </h4>
      </section>
      <section data-testid={'FullQuestion-sectionTwo'} className={hideWhenPreview}>
        <section className={styles.vpQuestionDescription}>{question.description}</section>
        <hr className={styles.vpQuestionSeparator} />
        <VideoPreview qid={qid} createMediaSubmissionFn={createMediaSubmissionFn} />
        <CameraRecord qid={qid} urlType="clpVideoUpload" />
        <RecordNotSupportedMessage />
        <UploadOrRecordSelector qid={qid} createMediaSubmissionFn={createMediaSubmissionFn} />

        <UploadError qid={qid} />
      </section>
    </>
  );
};

FullQuestion.propTypes = {
  _hideFullQuestion: PropTypes.func,
  createMediaSubmissionFn: PropTypes.func,
  hasUploadedVideo: PropTypes.bool,
  isPreview: PropTypes.bool,
  question: PropTypes.object,
  qid: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  return {
    question: getCampaignElementById(state, ownProps.qid),
    isPreview: getIsQuestionPreview(state, ownProps.qid),
  };
}

const mapDispatchToProps = {
  _hideFullQuestion: hideFullQuestion,
};

export default connect(mapStateToProps, mapDispatchToProps)(FullQuestion);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/FullQuestion.jsx